export default class ContactForm {
  constructor(element) {
    this.element = element;
    this.submitButton = this.element.querySelector('button[type="submit"]');
    this.status = this.element.querySelector('.contact-form__status');
    this.init();
  }

  init() {
    this.element.addEventListener('submit', (event) => this.handleSubmit(event));
  }

  async handleSubmit(event) {
    event.preventDefault();

    if (!this.element.checkValidity()) {
      this.element.reportValidity();
      return;
    }

    this.setLoading(true);
    this.setStatus('');

    try {
      const response = await fetch(this.element.action, {
        method: 'POST',
        body: new FormData(this.element),
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      });
      const result = await response.json();

      if (!response.ok || !result.success) {
        throw new Error(result.message || 'Le message n’a pas pu être envoyé.');
      }

      this.trackSuccess();
      this.element.reset();
      this.setStatus(result.message || 'Merci, votre message a bien été envoyé.', 'success');
    } catch (error) {
      this.setStatus(error.message || 'Le message n’a pas pu être envoyé.', 'error');
    } finally {
      this.setLoading(false);
    }
  }

  setLoading(isLoading) {
    if (!this.submitButton) {
      return;
    }

    this.submitButton.disabled = isLoading;
    this.submitButton.classList.toggle('is-loading', isLoading);
    this.submitButton.querySelector('span').textContent = isLoading ? 'Envoi en cours...' : 'Envoyer le message';
  }

  setStatus(message, type = '') {
    if (!this.status) {
      return;
    }

    this.status.textContent = message;
    this.status.dataset.status = type;
  }

  trackSuccess() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'contact_form_submit_success',
      form_id: this.element.dataset.formId || 'marc_contact_form',
      form_name: this.element.dataset.formName || 'Contact Marc Campillo',
      form_destination: 'marc.campillo@usherbrooke.ca',
      page_location: window.location.href,
      page_path: window.location.pathname,
    });
  }
}
